import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Send = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M10.1097 13.65L13.6897 10.06M7.39969 6.31997L15.8897 3.48997C19.6997 2.21997 21.7697 4.29997 20.5097 8.10997L17.6797 16.6C15.7797 22.31 12.6597 22.31 10.7597 16.6L9.91969 14.08L7.39969 13.24C1.68969 11.34 1.68969 8.22997 7.39969 6.31997Z",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
